import React from 'react';
import { Transfer } from 'antd';
import { connect } from 'react-redux';

import { userListLoad } from "store/models/user";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const UserTransferField = (props) => {
  return (
    <ListLoadComponent
      apiLoad={userListLoad}
      filter={{ simple: true }}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, ...otherProps } = props;
        const dataSource = items.map(item => {
          item.key = item.id;
          return item;
        });
        return (
          <FormItem {...otherProps} valuePropName='targetKeys'>
            <Transfer
              dataSource={dataSource}
              showSearch
              listStyle={{
                width: 250,
                height: 300,
              }}
              render={item => `${item.email}`}
            />
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.user,
});

export default connect(mapState)(UserTransferField);
